'use strict';
(function() {
  var w;
  var x = {"\u00c1":"A", "\u0102":"A", "\u1eae":"A", "\u1eb6":"A", "\u1eb0":"A", "\u1eb2":"A", "\u1eb4":"A", "\u01cd":"A", "\u00c2":"A", "\u1ea4":"A", "\u1eac":"A", "\u1ea6":"A", "\u1ea8":"A", "\u1eaa":"A", "\u00c4":"A", "\u01de":"A", "\u0226":"A", "\u01e0":"A", "\u1ea0":"A", "\u0200":"A", "\u00c0":"A", "\u1ea2":"A", "\u0202":"A", "\u0100":"A", "\u0104":"A", "\u00c5":"A", "\u01fa":"A", "\u1e00":"A", "\u023a":"A", "\u00c3":"A", "\ua732":"AA", "\u00c6":"AE", "\u01fc":"AE", "\u01e2":"AE", "\ua734":"AO", 
  "\ua736":"AU", "\ua738":"AV", "\ua73a":"AV", "\ua73c":"AY", "\u1e02":"B", "\u1e04":"B", "\u0181":"B", "\u1e06":"B", "\u0243":"B", "\u0182":"B", "\u0106":"C", "\u010c":"C", "\u00c7":"C", "\u1e08":"C", "\u0108":"C", "\u010a":"C", "\u0187":"C", "\u023b":"C", "\u010e":"D", "\u1e10":"D", "\u1e12":"D", "\u1e0a":"D", "\u1e0c":"D", "\u018a":"D", "\u1e0e":"D", "\u01f2":"D", "\u01c5":"D", "\u0110":"D", "\u018b":"D", "\u01f1":"DZ", "\u01c4":"DZ", "\u00c9":"E", "\u0114":"E", "\u011a":"E", "\u0228":"E", "\u1e1c":"E", 
  "\u00ca":"E", "\u1ebe":"E", "\u1ec6":"E", "\u1ec0":"E", "\u1ec2":"E", "\u1ec4":"E", "\u1e18":"E", "\u00cb":"E", "\u0116":"E", "\u1eb8":"E", "\u0204":"E", "\u00c8":"E", "\u1eba":"E", "\u0206":"E", "\u0112":"E", "\u1e16":"E", "\u1e14":"E", "\u0118":"E", "\u0246":"E", "\u1ebc":"E", "\u1e1a":"E", "\ua76a":"ET", "\u1e1e":"F", "\u0191":"F", "\u01f4":"G", "\u011e":"G", "\u01e6":"G", "\u0122":"G", "\u011c":"G", "\u0120":"G", "\u0193":"G", "\u1e20":"G", "\u01e4":"G", "\u1e2a":"H", "\u021e":"H", "\u1e28":"H", 
  "\u0124":"H", "\u2c67":"H", "\u1e26":"H", "\u1e22":"H", "\u1e24":"H", "\u0126":"H", "\u00cd":"I", "\u012c":"I", "\u01cf":"I", "\u00ce":"I", "\u00cf":"I", "\u1e2e":"I", "\u0130":"I", "\u1eca":"I", "\u0208":"I", "\u00cc":"I", "\u1ec8":"I", "\u020a":"I", "\u012a":"I", "\u012e":"I", "\u0197":"I", "\u0128":"I", "\u1e2c":"I", "\ua779":"D", "\ua77b":"F", "\ua77d":"G", "\ua782":"R", "\ua784":"S", "\ua786":"T", "\ua76c":"IS", "\u0134":"J", "\u0248":"J", "\u1e30":"K", "\u01e8":"K", "\u0136":"K", "\u2c69":"K", 
  "\ua742":"K", "\u1e32":"K", "\u0198":"K", "\u1e34":"K", "\ua740":"K", "\ua744":"K", "\u0139":"L", "\u023d":"L", "\u013d":"L", "\u013b":"L", "\u1e3c":"L", "\u1e36":"L", "\u1e38":"L", "\u2c60":"L", "\ua748":"L", "\u1e3a":"L", "\u013f":"L", "\u2c62":"L", "\u01c8":"L", "\u0141":"L", "\u01c7":"LJ", "\u1e3e":"M", "\u1e40":"M", "\u1e42":"M", "\u2c6e":"M", "\u0143":"N", "\u0147":"N", "\u0145":"N", "\u1e4a":"N", "\u1e44":"N", "\u1e46":"N", "\u01f8":"N", "\u019d":"N", "\u1e48":"N", "\u0220":"N", "\u01cb":"N", 
  "\u00d1":"N", "\u01ca":"NJ", "\u00d3":"O", "\u014e":"O", "\u01d1":"O", "\u00d4":"O", "\u1ed0":"O", "\u1ed8":"O", "\u1ed2":"O", "\u1ed4":"O", "\u1ed6":"O", "\u00d6":"O", "\u022a":"O", "\u022e":"O", "\u0230":"O", "\u1ecc":"O", "\u0150":"O", "\u020c":"O", "\u00d2":"O", "\u1ece":"O", "\u01a0":"O", "\u1eda":"O", "\u1ee2":"O", "\u1edc":"O", "\u1ede":"O", "\u1ee0":"O", "\u020e":"O", "\ua74a":"O", "\ua74c":"O", "\u014c":"O", "\u1e52":"O", "\u1e50":"O", "\u019f":"O", "\u01ea":"O", "\u01ec":"O", "\u00d8":"O", 
  "\u01fe":"O", "\u00d5":"O", "\u1e4c":"O", "\u1e4e":"O", "\u022c":"O", "\u01a2":"OI", "\ua74e":"OO", "\u0190":"E", "\u0186":"O", "\u0222":"OU", "\u1e54":"P", "\u1e56":"P", "\ua752":"P", "\u01a4":"P", "\ua754":"P", "\u2c63":"P", "\ua750":"P", "\ua758":"Q", "\ua756":"Q", "\u0154":"R", "\u0158":"R", "\u0156":"R", "\u1e58":"R", "\u1e5a":"R", "\u1e5c":"R", "\u0210":"R", "\u0212":"R", "\u1e5e":"R", "\u024c":"R", "\u2c64":"R", "\ua73e":"C", "\u018e":"E", "\u015a":"S", "\u1e64":"S", "\u0160":"S", "\u1e66":"S", 
  "\u015e":"S", "\u015c":"S", "\u0218":"S", "\u1e60":"S", "\u1e62":"S", "\u1e68":"S", "\u0164":"T", "\u0162":"T", "\u1e70":"T", "\u021a":"T", "\u023e":"T", "\u1e6a":"T", "\u1e6c":"T", "\u01ac":"T", "\u1e6e":"T", "\u01ae":"T", "\u0166":"T", "\u2c6f":"A", "\ua780":"L", "\u019c":"M", "\u0245":"V", "\ua728":"TZ", "\u00da":"U", "\u016c":"U", "\u01d3":"U", "\u00db":"U", "\u1e76":"U", "\u00dc":"U", "\u01d7":"U", "\u01d9":"U", "\u01db":"U", "\u01d5":"U", "\u1e72":"U", "\u1ee4":"U", "\u0170":"U", "\u0214":"U", 
  "\u00d9":"U", "\u1ee6":"U", "\u01af":"U", "\u1ee8":"U", "\u1ef0":"U", "\u1eea":"U", "\u1eec":"U", "\u1eee":"U", "\u0216":"U", "\u016a":"U", "\u1e7a":"U", "\u0172":"U", "\u016e":"U", "\u0168":"U", "\u1e78":"U", "\u1e74":"U", "\ua75e":"V", "\u1e7e":"V", "\u01b2":"V", "\u1e7c":"V", "\ua760":"VY", "\u1e82":"W", "\u0174":"W", "\u1e84":"W", "\u1e86":"W", "\u1e88":"W", "\u1e80":"W", "\u2c72":"W", "\u1e8c":"X", "\u1e8a":"X", "\u00dd":"Y", "\u0176":"Y", "\u0178":"Y", "\u1e8e":"Y", "\u1ef4":"Y", "\u1ef2":"Y", 
  "\u01b3":"Y", "\u1ef6":"Y", "\u1efe":"Y", "\u0232":"Y", "\u024e":"Y", "\u1ef8":"Y", "\u0179":"Z", "\u017d":"Z", "\u1e90":"Z", "\u2c6b":"Z", "\u017b":"Z", "\u1e92":"Z", "\u0224":"Z", "\u1e94":"Z", "\u01b5":"Z", "\u0132":"IJ", "\u0152":"OE", "\u1d00":"A", "\u1d01":"AE", "\u0299":"B", "\u1d03":"B", "\u1d04":"C", "\u1d05":"D", "\u1d07":"E", "\ua730":"F", "\u0262":"G", "\u029b":"G", "\u029c":"H", "\u026a":"I", "\u0281":"R", "\u1d0a":"J", "\u1d0b":"K", "\u029f":"L", "\u1d0c":"L", "\u1d0d":"M", "\u0274":"N", 
  "\u1d0f":"O", "\u0276":"OE", "\u1d10":"O", "\u1d15":"OU", "\u1d18":"P", "\u0280":"R", "\u1d0e":"N", "\u1d19":"R", "\ua731":"S", "\u1d1b":"T", "\u2c7b":"E", "\u1d1a":"R", "\u1d1c":"U", "\u1d20":"V", "\u1d21":"W", "\u028f":"Y", "\u1d22":"Z", "\u00e1":"a", "\u0103":"a", "\u1eaf":"a", "\u1eb7":"a", "\u1eb1":"a", "\u1eb3":"a", "\u1eb5":"a", "\u01ce":"a", "\u00e2":"a", "\u1ea5":"a", "\u1ead":"a", "\u1ea7":"a", "\u1ea9":"a", "\u1eab":"a", "\u00e4":"a", "\u01df":"a", "\u0227":"a", "\u01e1":"a", "\u1ea1":"a", 
  "\u0201":"a", "\u00e0":"a", "\u1ea3":"a", "\u0203":"a", "\u0101":"a", "\u0105":"a", "\u1d8f":"a", "\u1e9a":"a", "\u00e5":"a", "\u01fb":"a", "\u1e01":"a", "\u2c65":"a", "\u00e3":"a", "\ua733":"aa", "\u00e6":"ae", "\u01fd":"ae", "\u01e3":"ae", "\ua735":"ao", "\ua737":"au", "\ua739":"av", "\ua73b":"av", "\ua73d":"ay", "\u1e03":"b", "\u1e05":"b", "\u0253":"b", "\u1e07":"b", "\u1d6c":"b", "\u1d80":"b", "\u0180":"b", "\u0183":"b", "\u0275":"o", "\u0107":"c", "\u010d":"c", "\u00e7":"c", "\u1e09":"c", 
  "\u0109":"c", "\u0255":"c", "\u010b":"c", "\u0188":"c", "\u023c":"c", "\u010f":"d", "\u1e11":"d", "\u1e13":"d", "\u0221":"d", "\u1e0b":"d", "\u1e0d":"d", "\u0257":"d", "\u1d91":"d", "\u1e0f":"d", "\u1d6d":"d", "\u1d81":"d", "\u0111":"d", "\u0256":"d", "\u018c":"d", "\u0131":"i", "\u0237":"j", "\u025f":"j", "\u0284":"j", "\u01f3":"dz", "\u01c6":"dz", "\u00e9":"e", "\u0115":"e", "\u011b":"e", "\u0229":"e", "\u1e1d":"e", "\u00ea":"e", "\u1ebf":"e", "\u1ec7":"e", "\u1ec1":"e", "\u1ec3":"e", "\u1ec5":"e", 
  "\u1e19":"e", "\u00eb":"e", "\u0117":"e", "\u1eb9":"e", "\u0205":"e", "\u00e8":"e", "\u1ebb":"e", "\u0207":"e", "\u0113":"e", "\u1e17":"e", "\u1e15":"e", "\u2c78":"e", "\u0119":"e", "\u1d92":"e", "\u0247":"e", "\u1ebd":"e", "\u1e1b":"e", "\ua76b":"et", "\u1e1f":"f", "\u0192":"f", "\u1d6e":"f", "\u1d82":"f", "\u01f5":"g", "\u011f":"g", "\u01e7":"g", "\u0123":"g", "\u011d":"g", "\u0121":"g", "\u0260":"g", "\u1e21":"g", "\u1d83":"g", "\u01e5":"g", "\u1e2b":"h", "\u021f":"h", "\u1e29":"h", "\u0125":"h", 
  "\u2c68":"h", "\u1e27":"h", "\u1e23":"h", "\u1e25":"h", "\u0266":"h", "\u1e96":"h", "\u0127":"h", "\u0195":"hv", "\u00ed":"i", "\u012d":"i", "\u01d0":"i", "\u00ee":"i", "\u00ef":"i", "\u1e2f":"i", "\u1ecb":"i", "\u0209":"i", "\u00ec":"i", "\u1ec9":"i", "\u020b":"i", "\u012b":"i", "\u012f":"i", "\u1d96":"i", "\u0268":"i", "\u0129":"i", "\u1e2d":"i", "\ua77a":"d", "\ua77c":"f", "\u1d79":"g", "\ua783":"r", "\ua785":"s", "\ua787":"t", "\ua76d":"is", "\u01f0":"j", "\u0135":"j", "\u029d":"j", "\u0249":"j", 
  "\u1e31":"k", "\u01e9":"k", "\u0137":"k", "\u2c6a":"k", "\ua743":"k", "\u1e33":"k", "\u0199":"k", "\u1e35":"k", "\u1d84":"k", "\ua741":"k", "\ua745":"k", "\u013a":"l", "\u019a":"l", "\u026c":"l", "\u013e":"l", "\u013c":"l", "\u1e3d":"l", "\u0234":"l", "\u1e37":"l", "\u1e39":"l", "\u2c61":"l", "\ua749":"l", "\u1e3b":"l", "\u0140":"l", "\u026b":"l", "\u1d85":"l", "\u026d":"l", "\u0142":"l", "\u01c9":"lj", "\u017f":"s", "\u1e9c":"s", "\u1e9b":"s", "\u1e9d":"s", "\u1e3f":"m", "\u1e41":"m", "\u1e43":"m", 
  "\u0271":"m", "\u1d6f":"m", "\u1d86":"m", "\u0144":"n", "\u0148":"n", "\u0146":"n", "\u1e4b":"n", "\u0235":"n", "\u1e45":"n", "\u1e47":"n", "\u01f9":"n", "\u0272":"n", "\u1e49":"n", "\u019e":"n", "\u1d70":"n", "\u1d87":"n", "\u0273":"n", "\u00f1":"n", "\u01cc":"nj", "\u00f3":"o", "\u014f":"o", "\u01d2":"o", "\u00f4":"o", "\u1ed1":"o", "\u1ed9":"o", "\u1ed3":"o", "\u1ed5":"o", "\u1ed7":"o", "\u00f6":"o", "\u022b":"o", "\u022f":"o", "\u0231":"o", "\u1ecd":"o", "\u0151":"o", "\u020d":"o", "\u00f2":"o", 
  "\u1ecf":"o", "\u01a1":"o", "\u1edb":"o", "\u1ee3":"o", "\u1edd":"o", "\u1edf":"o", "\u1ee1":"o", "\u020f":"o", "\ua74b":"o", "\ua74d":"o", "\u2c7a":"o", "\u014d":"o", "\u1e53":"o", "\u1e51":"o", "\u01eb":"o", "\u01ed":"o", "\u00f8":"o", "\u01ff":"o", "\u00f5":"o", "\u1e4d":"o", "\u1e4f":"o", "\u022d":"o", "\u01a3":"oi", "\ua74f":"oo", "\u025b":"e", "\u1d93":"e", "\u0254":"o", "\u1d97":"o", "\u0223":"ou", "\u1e55":"p", "\u1e57":"p", "\ua753":"p", "\u01a5":"p", "\u1d71":"p", "\u1d88":"p", "\ua755":"p", 
  "\u1d7d":"p", "\ua751":"p", "\ua759":"q", "\u02a0":"q", "\u024b":"q", "\ua757":"q", "\u0155":"r", "\u0159":"r", "\u0157":"r", "\u1e59":"r", "\u1e5b":"r", "\u1e5d":"r", "\u0211":"r", "\u027e":"r", "\u1d73":"r", "\u0213":"r", "\u1e5f":"r", "\u027c":"r", "\u1d72":"r", "\u1d89":"r", "\u024d":"r", "\u027d":"r", "\u2184":"c", "\ua73f":"c", "\u0258":"e", "\u027f":"r", "\u015b":"s", "\u1e65":"s", "\u0161":"s", "\u1e67":"s", "\u015f":"s", "\u015d":"s", "\u0219":"s", "\u1e61":"s", "\u1e63":"s", "\u1e69":"s", 
  "\u0282":"s", "\u1d74":"s", "\u1d8a":"s", "\u023f":"s", "\u0261":"g", "\u1d11":"o", "\u1d13":"o", "\u1d1d":"u", "\u0165":"t", "\u0163":"t", "\u1e71":"t", "\u021b":"t", "\u0236":"t", "\u1e97":"t", "\u2c66":"t", "\u1e6b":"t", "\u1e6d":"t", "\u01ad":"t", "\u1e6f":"t", "\u1d75":"t", "\u01ab":"t", "\u0288":"t", "\u0167":"t", "\u1d7a":"th", "\u0250":"a", "\u1d02":"ae", "\u01dd":"e", "\u1d77":"g", "\u0265":"h", "\u02ae":"h", "\u02af":"h", "\u1d09":"i", "\u029e":"k", "\ua781":"l", "\u026f":"m", "\u0270":"m", 
  "\u1d14":"oe", "\u0279":"r", "\u027b":"r", "\u027a":"r", "\u2c79":"r", "\u0287":"t", "\u028c":"v", "\u028d":"w", "\u028e":"y", "\ua729":"tz", "\u00fa":"u", "\u016d":"u", "\u01d4":"u", "\u00fb":"u", "\u1e77":"u", "\u00fc":"u", "\u01d8":"u", "\u01da":"u", "\u01dc":"u", "\u01d6":"u", "\u1e73":"u", "\u1ee5":"u", "\u0171":"u", "\u0215":"u", "\u00f9":"u", "\u1ee7":"u", "\u01b0":"u", "\u1ee9":"u", "\u1ef1":"u", "\u1eeb":"u", "\u1eed":"u", "\u1eef":"u", "\u0217":"u", "\u016b":"u", "\u1e7b":"u", "\u0173":"u", 
  "\u1d99":"u", "\u016f":"u", "\u0169":"u", "\u1e79":"u", "\u1e75":"u", "\u1d6b":"ue", "\ua778":"um", "\u2c74":"v", "\ua75f":"v", "\u1e7f":"v", "\u028b":"v", "\u1d8c":"v", "\u2c71":"v", "\u1e7d":"v", "\ua761":"vy", "\u1e83":"w", "\u0175":"w", "\u1e85":"w", "\u1e87":"w", "\u1e89":"w", "\u1e81":"w", "\u2c73":"w", "\u1e98":"w", "\u1e8d":"x", "\u1e8b":"x", "\u1d8d":"x", "\u00fd":"y", "\u0177":"y", "\u00ff":"y", "\u1e8f":"y", "\u1ef5":"y", "\u1ef3":"y", "\u01b4":"y", "\u1ef7":"y", "\u1eff":"y", "\u0233":"y", 
  "\u1e99":"y", "\u024f":"y", "\u1ef9":"y", "\u017a":"z", "\u017e":"z", "\u1e91":"z", "\u0291":"z", "\u2c6c":"z", "\u017c":"z", "\u1e93":"z", "\u0225":"z", "\u1e95":"z", "\u1d76":"z", "\u1d8e":"z", "\u0290":"z", "\u01b6":"z", "\u0240":"z", "\ufb00":"ff", "\ufb03":"ffi", "\ufb04":"ffl", "\ufb01":"fi", "\ufb02":"fl", "\u0133":"ij", "\u0153":"oe", "\ufb06":"st", "\u2090":"a", "\u2091":"e", "\u1d62":"i", "\u2c7c":"j", "\u2092":"o", "\u1d63":"r", "\u1d64":"u", "\u1d65":"v", "\u2093":"x"};
  String.prototype.latinise = function() {
    return this.replace(/[^A-Za-z0-9\[\] ]/g, function(k) {
      return x[k] || k;
    });
  };
  String.prototype.latinize = String.prototype.latinise;
  String.prototype.isLatin = function() {
    return this == this.latinise();
  };
  window.slate = window.slate || {};
  slate.Variants = function() {
    function k(e) {
      this.container = e.container;
      this.variants = e.variants;
      this.originalSelectorId = e.originalSelectorId;
      this.enableHistoryState = e.enableHistoryState;
      this.singleOptionSelector = e.singleOptionSelector;
      this.imageSetName = e.imageSetName;
      this.autoSelection = e.autoSelection;
      this.currentVariant = this._getVariantFromOptions();
      this.container.querySelectorAll(this.singleOptionSelector).forEach(d => {
        d.addEventListener("change", this._onSelectChange.bind(this));
      });
    }
    k.prototype = Object.assign({}, k.prototype, {_getCurrentOptions:function() {
      var e = [];
      this.container.querySelectorAll(this.singleOptionSelector).forEach(d => {
        var g = !1;
        "true" == d.dataset.custom && d.name != this.imageSetName && (g = !0);
        var a = d.getAttribute("type");
        a = "radio" === a || "checkbox" === a;
        (!a || d.checked && a) && e.push({value:d.value, index:d.dataset.index, custom:g});
      });
      return e = theme.Helpers.compact(e);
    }, _getVariantFromOptions:function(e) {
      var d = this._getCurrentOptions(), g = !1;
      var a = this.variants.find(b => {
        const f = d.every(({value:h, index:m}) => b[m] === h);
        if (f && b.available) {
          return g = !0;
        }
        g = !1;
        return f;
      });
      if (!g && e) {
        var c = (e && this.variants.filter(b => d.filter(({index:f}) => parseInt(f.substr(-1)) <= parseInt(e.index.substr(-1))).every(({value:f, index:h}) => b[h] === f) && b.available)).reduce((b, f) => null === b ? f : b, null);
        c && (a = c);
      }
      return a;
    }, _onSelectChange:function(e) {
      var d = this._getVariantFromOptions({index:e.srcElement.dataset.index, value:e.srcElement.value});
      d && (this.container.querySelectorAll(this.singleOptionSelector).forEach(g => {
        const a = g.dataset.index, c = g.value, b = g.getAttribute("type");
        "radio" === b || "checkbox" === b ? g.checked = d[a] === c : g.value = d[a];
      }), void 0 != d && (this.container.classList.contains("variant-wrapper--dropdown") && this._updateBundleVariant(d), this.container.dispatchEvent(new CustomEvent("variantChange", {detail:{variant:d, currentVariant:this._getCurrentOptions()}}), function() {
        var g = document.querySelector("[data-bar-price]");
        g && null != d && (g.innerText = theme.Currency.formatMoney(d.price, theme.settings.moneyFormat));
      }()), d && (this._updateSubscribe(), this._updateMasterSelect(d), this._updateImages(d), this._updatePrice(d), this._updateUnitPrice(d), this._updateSKU(d), this.currentVariant = d, this.enableHistoryState && this._updateHistoryState(d))));
    }, _updateBundleVariant:function(e) {
      var d = this.container.querySelector("#BundleProductVariant-" + this.container.dataset.index);
      1 == e.available ? (this.container.dataset.id = e.id, d.style.opacity = "1") : (this.container.dataset.id = "", d.style.opacity = "0.5");
    }, _updateImages:function(e) {
      if (this.currentVariant) {
        var d = e.featured_image || {}, g = this.currentVariant.featured_image || {};
        e.featured_image && d.src !== g.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", {detail:{variant:e}}));
      }
    }, _updatePrice:function(e) {
      e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.container.dispatchEvent(new CustomEvent("variantPriceChange", {detail:{variant:e}}));
    }, _updateUnitPrice:function(e) {
      e.unit_price !== this.currentVariant.unit_price && this.container.dispatchEvent(new CustomEvent("variantUnitPriceChange", {detail:{variant:e}}));
    }, _updateSKU:function(e) {
      e.sku !== this.currentVariant.sku && this.container.dispatchEvent(new CustomEvent("variantSKUChange", {detail:{variant:e}}));
    }, _updateHistoryState:function(e) {
      if (history.replaceState && e) {
        var d = "";
        null != w && null != e[w] && (d = "?type=" + e[w]);
        e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
        window.history.replaceState({path:e}, "", e + d);
      }
    }, _updateMasterSelect:function(e) {
      const d = this.container.getAttribute("data-section-id");
      document.querySelectorAll(`#AddToCartForm-${d}, #product-form-installment-${d}`).forEach(g => {
        var a = g.querySelector('input[name="id"]');
        null != a && (a.value = e.id);
        g = g.querySelector(this.originalSelectorId);
        null != g ? (g.value = e.id, g.dispatchEvent(new Event("change", {bubbles:!0}))) : a.dispatchEvent(new Event("change", {bubbles:!0}));
      });
    }, _updateSubscribe:function() {
      var e = this.container.querySelector(".btn--subscribed");
      null != e && 0 == e.classList.contains("hide") && e.classList.add("hide");
    }});
    return k;
  }();
  theme.ProductBundle = function() {
    function k(e) {
      this.container = e;
      this.init();
    }
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      parseInt(this.container.getAttribute("data-section-id"));
      this.container.getAttribute("data-collection-id");
      var e = parseInt(this.container.getAttribute("data-bundle-id"));
      parseInt(this.container.getAttribute("data-product-id"));
      var d = this.container.getAttribute("data-block-id");
      parseInt(this.container.getAttribute("data-blocks"));
      var g = parseInt(this.container.getAttribute("data-index"));
      document.getElementById("BundleProductVariant-" + g);
      this.cartBtnText = document.querySelector("[data-add-to-cart-text]");
      this.resizeWindow(e);
      this.container.querySelectorAll(".product__bundle--product").forEach(a => {
        a.addEventListener("change", function(c) {
          var b = c.currentTarget.id;
          b = b.charAt(b.length - 1);
          document.getElementById("BundleProductVariant-" + b);
          var f = c.target[c.target.selectedIndex], h = 0;
          if (f) {
            h = parseInt(f.getAttribute("data-index").replace("option", ""));
            this.productSelectWrapper = document.getElementById("BundleVariantWrapper-" + b + "--" + h);
            var m = document.getElementById(e + "--" + d).getElementsByClassName("product__bundle"), p = c.target[c.target.selectedIndex].dataset.productid;
            null != this.productSelectWrapper && "true" == this.productSelectWrapper.getAttribute("data-set-vailability") && (c = this.productSelectWrapper.querySelector("[data-bundle-variant-json]"), c = JSON.parse(c.innerHTML), f = this.productSelectWrapper.querySelector("[data-bundle-current-variant-json]"), f = JSON.parse(f.innerHTML), theme.SetAvailability.init(null, this.currentVariantObject, c, this.productSelectWrapper, "dropdown", f));
            this.container.querySelectorAll("[data-wrapperid]").forEach(function(l, n) {
              l && (null == p && 0 == n || m[n].id == p ? m[n].classList.remove("hide") : m[n].classList.add("hide"), l.classList.add("hide"), l.classList.remove("product__bundle--selected"));
            });
            this.productSelectWrapper ? null != p ? this.updateBundle(!0, b, this.productSelectWrapper) : this.updateBundle(!1, b, this.productSelectWrapper) : this.updateBundle(!1, b, null);
          }
        }.bind(this));
      });
      this.container.querySelectorAll(".variant-wrapper--dropdown").forEach(a => {
        if ("true" == a.getAttribute("data-set-vailability")) {
          a.querySelector("[data-bundle-variant-input]");
          var c = a.querySelector("[data-bundle-variant-json]");
          c = JSON.parse(c.innerHTML);
          var b = a.querySelector("[data-bundle-current-variant-json]"), f = JSON.parse(b.innerHTML), h = {container:a, enableHistoryState:!1, singleOptionSelector:".bundle-variant-input-wrap", originalSelectorId:a.querySelector("[data-bundle-variant-input]"), variants:c, autoSelection:!1}, m = new slate.Variants(h);
          a.addEventListener("change", function(p) {
            theme.SetAvailability.init(null, m.currentVariant, h.variants, h.container, "dropdown", f);
          }.bind(this));
        }
      });
    }, resizeWindow:function(e) {
      document.addEventListener("DOMContentLoaded", function() {
        setTimeout(function() {
          var d = document.querySelector(".bundle__image-" + e);
          null != d && (d.style.minHeight = d.offsetHeight + "px");
        }, 500);
      }, !1);
    }, updateSeparator:function(e, d) {
      e = document.querySelector(".bundle__separator-" + e);
      null != e && (e.style.opacity = d);
    }, updateBundle:function(e, d, g) {
      document.querySelectorAll(".bundle__image-" + d).forEach(b => {
        e ? (b.style.opacity = "1", g.classList.add("product__bundle--selected"), g.classList.remove("hide"), document.getElementById("BundleProduct-" + d).options[0].innerHTML = "\uff0d " + theme.strings.removeItem) : (b.style.opacity = "0.5", document.getElementById("BundleProduct-" + d).options[0].innerHTML = theme.strings.selectItem);
      });
      var a = document.querySelector("#BundleProduct-" + (parseInt(d) - 1)), c = document.querySelector("#BundleProduct-" + (parseInt(d) + 1));
      e ? (null != a && 0 < a.selectedIndex && this.updateSeparator(d, 1), null != c && 0 < c.selectedIndex && this.updateSeparator(parseInt(d) + 1, 1)) : (null != a && 0 < a.selectedIndex && this.updateSeparator(d, 0.5), null != c && 0 < c.selectedIndex && this.updateSeparator(parseInt(d) + 1, 0.5));
      this.updateCartButton();
    }, updateCartButton:function(e) {
      if (this.cartBtnText.textContent != theme.strings.unavailable && this.cartBtnText.textContent != theme.strings.soldOut) {
        e = !1;
        for (let d = 0; 5 > d; d++) {
          if (null != document.getElementById("BundleProduct-" + d) && 0 < document.getElementById("BundleProduct-" + d).selectedIndex) {
            e = !0;
            break;
          }
        }
        1 == e ? (this.cartBtnText.textContent = theme.strings.addAllToCart, this.cartBtnText.setAttribute("data-value", theme.strings.addAllToCart)) : (this.cartBtnText.textContent = theme.strings.addToCart, this.cartBtnText.setAttribute("data-value", theme.strings.addToCart));
      }
    }});
    return k;
  }();
  theme.SetAvailability = {init:function(k, e, d, g, a, c) {
    this.type = a;
    if (null === k || void 0 === k) {
      g.querySelectorAll(".variant-input-wrap").forEach(m => {
        this.disableVariantGroup(m);
      });
      var b = c.options.map((m, p) => ({value:m, index:`option${p + 1}`}));
    } else {
      b = k.detail.currentVariant;
    }
    k = d.reduce((m, p) => {
      Object.keys(m).forEach(l => {
        if (null !== p[l]) {
          var n = m[l].find(u => u.value === p[l]);
          "undefined" === typeof n && (n = {value:p[l], soldOut:!0}, m[l].push(n));
          var q, r;
          for (let u = 1; 2 >= u; u++) {
            var t = "option" + u, v = b.find(({index:y}) => y === t);
            1 == u ? q = v : r = v;
          }
          switch(l) {
            case "option1":
              n.soldOut = n.soldOut && p.available ? !1 : n.soldOut;
              break;
            case "option2":
              q && p.option1 === q.value && (n.soldOut = n.soldOut && p.available ? !1 : n.soldOut);
            case "option3":
              q && p.option1 === q.value && r && p.option2 === r.value && (n.soldOut = n.soldOut && p.available ? !1 : n.soldOut);
          }
        }
      });
      return m;
    }, {option1:[], option2:[], option3:[]});
    var f, h;
    for ([f, h] of Object.entries(k)) {
      this.manageOptionState(f, h, g);
    }
  }, manageOptionState:function(k, e, d) {
    var g = "dropdown" === this.type ? d.querySelector('.bundle-variant-input-wrap[data-index="' + k + '"]') : d.querySelector('.variant-input-wrapper[data-index="' + k + '"]');
    e.forEach(a => {
      this.enableVariantOption(g, a);
    });
  }, enableVariantOption:function(k, e) {
    var d = e.value.replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, "\\$1");
    "dropdown" === this.type ? e.soldOut ? k.querySelector('option[value="' + d + '"]').disabled = !0 : k.querySelector('option[value="' + d + '"]').disabled = !1 : (d = k.querySelector('.variant-input[data-value="' + d + '"]'), null != d && (k = d.querySelector("input"), d = d.querySelector("label"), k.classList.remove("disabled"), d.classList.remove("disabled"), e.soldOut && (k.classList.add("disabled"), d.classList.add("disabled"))));
  }, disableVariantGroup:function(k) {
    "dropdown" === this.type ? k.querySelectorAll("option").forEach(e => {
      e.disabled = "choose" != e.dataset.index ? !0 : !1;
    }) : (k.querySelectorAll("input").forEach(e => {
      e.classList.add("disabled");
    }), k.querySelectorAll("label").forEach(e => {
      e.classList.add("disabled");
    }));
  }};
  theme.AjaxProduct = function() {
    function k(d, g) {
      if (this.form = d) {
        this.addToCart = d.querySelector(g ? g : ".btn"), this.form && this.form.action.includes("/cart/add") && this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }
    var e = !1;
    k.prototype = Object.assign({}, k.prototype, {addItemFromForm:function(d, g) {
      d.preventDefault();
      if (!e) {
        this.addToCart && this.addToCart.classList.add("btn--loading");
        if (this.addToCart && "true" == this.addToCart.dataset.datepicker) {
          var a = this.form.querySelector(".custom-variant-quantity");
          a && (this.form.querySelector(".datepicker-date").value += "%" + a.dataset.name + a.value);
        }
        e = !0;
        g = theme.Helpers.serialize(this.form);
        if (this.addToCart && "true" == this.addToCart.dataset.datepicker) {
          const b = new URL("https://decod.er/?" + g);
          b.searchParams.get("id");
          var c = b.searchParams.get("quantity") ? parseInt(b.searchParams.get("quantity")) : 1;
          g = (d = this.form.querySelector(".datepicker-quantity")) && 0 != d.value ? parseInt(d.value) : 1;
          "true" == d.dataset.multipler ? (1 == c && (c = d.id.replace("SelectedEventQty-", ""), c = document.getElementById("Quantity-" + c).value), c *= g) : c = g;
          a && "false" == a.dataset.disabled && (c *= a.value);
          b.searchParams.set("quantity", c);
          g = b.search.substring(1);
          if (0 == d.value) {
            this.form.closest(".product-single__meta").querySelector(".calendarWrapper").parentNode.scrollIntoView();
            this.addToCart.classList.remove("btn--loading");
            e = !1;
            return;
          }
        }
        this.addToCart && "true" == this.addToCart.dataset.downloader ? ("true" != this.addToCart.dataset.login && (a = this.form.closest(".product-single__meta")) && (a = a.querySelector("[data-product-single-audio]") ? a.querySelector("[data-product-single-audio]").src : null) && (window.location = a), e = !1, this.addToCart && this.addToCart.classList.remove("btn--loading")) : fetch(theme.routes.cartAdd, {method:"POST", body:g, credentials:"same-origin", headers:{"Content-Type":"application/x-www-form-urlencoded", 
        "X-Requested-With":"XMLHttpRequest"}}).then(b => b.json()).then(function(b) {
          422 === b.status ? (this.error(b), this.success(b, !0)) : this.success(b, !1);
          e = !1;
          this.addToCart && this.addToCart.classList.remove("btn--loading");
          theme.announcementBar.update();
          document.body.classList.contains("template-cart") && (window.scrollTo(0, 0), location.reload());
        }.bind(this));
      }
    }, success:function(d, g) {
      var a = this.form.querySelector(".errors");
      a ? 1 == g ? document.querySelector(".drawer__scrollable.cart-drawer-form") && (this.removeError(), document.querySelectorAll(".drawer__scrollable.cart-drawer-form").forEach(b => {
        b.insertBefore(a, b.firstChild);
      })) : (a.remove(), this.removeError()) : document.querySelector(".drawer__scrollable.cart-drawer-form .errors") && this.removeError();
      var c = [];
      document.querySelectorAll(".variant-wrapper--dropdown").forEach(b => {
        if (b.classList.contains("product__bundle--selected")) {
          var f = b.dataset.id;
          if ("" != f) {
            b = parseInt(b.dataset.quantity);
            c.some((m, p) => c.indexOf(m) !== p);
            var h = c.findIndex(m => m.id == f);
            null != c[h] ? c[h].quantity = parseInt(c[h].quantity) + b : c.push({id:f, quantity:b});
          }
        }
      });
      0 < c.length ? fetch("/cart/add.js", {method:"POST", credentials:"same-origin", body:JSON.stringify({items:c}), headers:{"Content-Type":"application/json", "X-Requested-With":"XMLHttpRequest"}}).then(b => {
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail:{}}));
        document.querySelector("#CartDrawer") || (window.location.pathname = theme.routes.cartPage);
      }) : (document.dispatchEvent(new CustomEvent("ajaxProduct:added", {detail:{product:d, addToCartBtn:this.addToCart}})), document.querySelector("#CartDrawer") || (window.location.pathname = theme.routes.cartPage));
    }, error:function(d) {
      if (d.description) {
        var g = this.form.querySelector(".errors");
        g && g.remove();
        g = document.createElement("div");
        g.classList.add("errors", "text-center");
        g.textContent = d.description;
        null != this.form.querySelector(".product-form__item--submit") ? this.form.querySelector(".product-form__item--submit").append(g) : this.form.append(g);
        document.dispatchEvent(new CustomEvent("ajaxProduct:error", {detail:{errorMessage:d.description}}));
      } else {
        console.warn(d);
      }
    }, removeError:function() {
      document.querySelectorAll(".drawer__scrollable.cart-drawer-form .errors").forEach(d => {
        d.remove();
      });
    }});
    return k;
  }();
  theme.PickupAvailability = function() {
    function k(e) {
      this.container = e;
      this.baseUrl = e.dataset.baseUrl;
      this.productTitle = e.dataset.productName;
    }
    k.prototype = Object.assign({}, k.prototype, {updateContent:function(e) {
      e = this.baseUrl + "/variants/" + e + "/?section_id=pickup-availability";
      this.container.innerHTML = "";
      var d = this;
      fetch(e).then(function(g) {
        return g.text();
      }).then(function(g) {
        "" !== g.trim() && (d.container.innerHTML = g, d.container.innerHTML = d.container.firstElementChild.innerHTML, d.container.querySelector(".js-drawer-open-availability") && (theme.collapsibles.trigger(d.container.querySelector(".js-drawer-open-availability")), null != d.container.querySelector("[data-availability-product-title]") && (d.container.querySelector("[data-availability-product-title]").textContent = d.productTitle)));
      });
    }});
    return k;
  }();
  theme.VariantAvailability = function() {
    function k(e) {
      this.type = e.type;
      this.variantsObject = e.variantsObject;
      this.currentVariantObject = e.currentVariantObject;
      this.container = e.container;
      this.namespace = e.namespace;
      this.init();
    }
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      this.container.on("variantChange" + this.namespace, this.setAvailability2.bind(this));
      this.setAvailability2();
    }, setAvailability2:function(e) {
      if (null === e || void 0 === e) {
        this.container.querySelectorAll(".variant-input-wrap").forEach(c => {
          this.disableVariantGroup(c);
        });
        var d = this.currentVariantObject.options.map((c, b) => ({value:c, index:`option${b + 1}`}));
      } else {
        d = e.detail.currentVariant;
      }
      e = this.variantsObject.reduce((c, b) => {
        Object.keys(c).forEach(f => {
          if (null !== b[f]) {
            var h = c[f].find(q => q.value === b[f]);
            "undefined" === typeof h && (h = {value:b[f], soldOut:!0}, c[f].push(h));
            var m, p;
            for (let q = 1; 2 >= q; q++) {
              var l = "option" + q, n = d.find(({index:r}) => r === l);
              1 == q ? m = n : p = n;
            }
            switch(f) {
              case "option1":
                h.soldOut = h.soldOut && b.available ? !1 : h.soldOut;
                break;
              case "option2":
                m && b.option1 === m.value && (h.soldOut = h.soldOut && b.available ? !1 : h.soldOut);
              case "option3":
                m && b.option1 === m.value && p && b.option2 === p.value && (h.soldOut = h.soldOut && b.available ? !1 : h.soldOut);
            }
          }
        });
        return c;
      }, {option1:[], option2:[], option3:[]});
      var g, a;
      for ([g, a] of Object.entries(e)) {
        this.manageOptionState(g, a);
      }
    }, manageOptionState:function(e, d) {
      var g = this.container.querySelector('.variant-input-wrap[data-index="' + e + '"]');
      d.forEach(a => {
        this.enableVariantOption(g, a);
      });
    }, enableVariantOption:function(e, d) {
      var g = d.value.replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, "\\$1");
      "dropdown" === this.type ? d.soldOut ? e.querySelector('option[value="' + g + '"]').disabled = !0 : e.querySelector('option[value="' + g + '"]').disabled = !1 : (g = e.querySelector('.variant-input[data-value="' + g + '"]'), null != g && (e = g.querySelector("input"), g = g.querySelector("label"), e.classList.remove("disabled"), g.classList.remove("disabled"), d.soldOut && (e.classList.add("disabled"), g.classList.contains("activeDate") || g.classList.add("disabled"))));
    }, disableVariantGroup:function(e) {
      "dropdown" === this.type ? e.querySelectorAll("option").forEach(d => {
        d.disabled = "choose" != d.dataset.index ? !0 : !1;
      }) : (e.querySelectorAll("input").forEach(d => {
        d.classList.add("disabled");
      }), e.querySelectorAll("label").forEach(d => {
        d.classList.contains("activeDate") || d.classList.add("disabled");
      }));
    }});
    return k;
  }();
  theme.footerheaderNav = function() {
    function k() {
      c.lastScroll = 0;
      var h = document.createElement("div");
      h.id = c.stickyHeaderWrapper;
      theme.Helpers.wrap(b, h);
      e();
      var m = window.innerWidth;
      window.on("resize" + c.namespace, theme.Helpers.debounce(50, function() {
        window.innerWidth != m && (m = window.innerWidth, e());
      }.bind(this)));
      window.on("scroll" + c.namespace, theme.Helpers.throttle(20, d));
    }
    function e() {
      f = null != document.getElementById("StickyBarTrigger") ? document.getElementById("StickyBarTrigger").getBoundingClientRect().top + window.scrollY : c.heightActivator;
      c.stickyEnabled && document.querySelector("#" + c.stickyHeaderWrapper);
    }
    function d() {
      requestAnimationFrame(g);
      c.lastScroll = window.scrollY;
    }
    function g() {
      b = document.querySelector(a.siteHeader);
      window.scrollY > f ? c.stickyActive || (c.stickyActive = !0, null != document.querySelector("#BackToTop") && document.querySelector("#BackToTop").classList.add("btn--back-to-top__padding"), b.classList.add(c.stickyClass), setTimeout(function() {
        b.classList.add(c.openTransitionClass);
      }, 100)) : c.stickyActive && (c.stickyActive = !1, null != document.querySelector("#BackToTop") && document.querySelector("#BackToTop").classList.remove("btn--back-to-top__padding"), b.classList.remove(c.openTransitionClass), b.classList.remove(c.stickyClass));
    }
    var a = {wrapper:"#FooterHeaderWrapper", siteHeader:"#StickyBar", section_id:""}, c = {namespace:".siteNav", stickyEnabled:!1, stickyActive:!1, stickyClass:"site-header-footer--stuck", stickyHeaderWrapper:"StickyHeaderWrap", openTransitionClass:"site-header-footer--opening", lastScroll:0, heightActivator:950}, b, f;
    return {init:function() {
      document.querySelector(a.wrapper);
      b = document.querySelector(a.siteHeader);
      c.heightActivator = parseInt(b.dataset.heightactivator);
      c.stickyEnabled = "true" === b.dataset.sticky;
      k();
    }};
  }();
  theme.FooterHeaderSection = function() {
    function k(e) {
      this.container = e;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.init();
    }
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      theme.footerheaderNav.init();
    }});
    return k;
  }();
  theme.Product = function() {
    function k(a, c, b) {
      var f = !1, h = document.createElement("textarea");
      h.value = a;
      h.setAttribute("readonly", "");
      h.style.position = "absolute";
      h.style.left = "-9999px";
      document.body.appendChild(h);
      0 < document.getSelection().rangeCount && (f = document.getSelection().getRangeAt(0));
      h.select();
      document.execCommand("copy");
      document.body.removeChild(h);
      f && (document.getSelection().removeAllRanges(), document.getSelection().addRange(f));
      c.classList.add("hide");
      setTimeout(function() {
        b.classList.remove("hide");
      }, 800);
    }
    function e(a) {
      this.container = a;
      g = this.sectionId = a.getAttribute("data-section-id");
      this.productId = a.getAttribute("data-product-id");
      this.stickyEnabled = a.getAttribute("data-sticky-enabled");
      this.settings = {enableHistoryState:a.dataset.history || !1, namespace:".product-" + g, inventory:a.dataset.inventory || !1, incomingInventory:a.dataset.incomingInventory || !1, modalInit:!1, hasImages:!0, imageSetName:null, imageSetIndex:null, currentImageSet:null, imageSize:"620x", currentSlideIndex:0, videoLooping:a.dataset.videoLooping, singleImage:!1};
      this.selectors = {addToCart:"[data-add-to-cart]", addToCartText:"[data-add-to-cart-text]", preorderText:"[data-preorder-text]", inventory:"[data-product-inventory]", incomingInventory:"[data-incoming-inventory]", SKU:"[data-sku-id]", originalSelectorId:"[data-product-select]", productForm:".product-single__form", newsletterForm:".newsletter-single__form", imageContainer:"[data-product-images]", productThumbImages:".product-single__thumbnails--scroller", productThumbs:"[data-product-thumbs]", 
      productImages:"#ProductImages-", productImagesMobile:"ProductImagesMobile-", productThumbListItem:".product-single__thumbnail-" + g, productMedia:"[data-product-media]", mainSlider:"#ProductPhotos-" + g, singleOptionSelector:".single-option-selector-" + g, shopifyPaymentButton:"[data-dynamic-cart-button]", media:"[data-product-media-type-model]", closeMedia:".product-single__close-media", regularPrice:"[data-regular-price]", salePrice:"[data-sale-price]", unitPrice:"[data-unit-price]", unitPriceBaseUnit:"[data-unit-price-base-unit]", 
      unitWrapper:"[data-unit-price-wrapper]", priceWrapper:"[data-product-price-wrap]", price:"[data-product-price]", comparePrice:"[data-compare-price]", variantInputId:"#VariantInputWrap-" + g, variantColorSwatch:".variant__input--color-swatch-" + g, modalFormHolder:"#ProductFormHolder-" + g, availabilityContainer:"[data-pickup-availability-holder]", variantsJson:"[data-variant-json]", currentVariantJson:"[data-current-variant-json]", variantType:".variant-wrapper", datepicker:".calendarWrapper"};
      this.cache = {form:a.querySelector(this.selectors.productForm), subscribe:a.querySelector(this.selectors.newsletterForm), mainSlider:a.querySelector(this.selectors.mainSlider), productThumbs:a.querySelector(this.selectors.productThumbs), productThumbImages:a.querySelector(this.selectors.productThumbImages), productMediaSlider:a.querySelector(this.selectors.productMedia), productImages:a.querySelector(this.selectors.imageContainer), priceWrapper:a.querySelector(this.selectors.priceWrapper), 
      salePrice:a.querySelector(this.selectors.salePrice), comparePrice:a.querySelector(this.selectors.comparePrice), price:a.querySelector(this.selectors.price), regularPrice:a.querySelector(this.selectors.regularPrice), datepicker:a.querySelector(this.selectors.datepicker)};
      this.selectorNames = ["[data-calendar-id]", "[data-opening-time]", "[data-closng-time]", "[data-length]", "[data-disabled]"];
      if (null == a.querySelector(this.selectors.productForm) || a.querySelector(this.selectors.productForm).classList.contains("disabled")) {
        this.cache.form = null;
      }
      if (this.cache.mainSlider) {
        this.firstProductImage = this.cache.mainSlider.querySelector("img");
        this.firstProductImage || (this.settings.hasImages = !1);
        var c = this.cache.mainSlider.querySelector("[data-set-name]");
        c && (this.settings.imageSetName = c.dataset.setName);
      }
      c = this.container.dataset.single;
      null != c && "true" == c && (this.settings.singleImage = !0);
      this.init();
      "true" == this.stickyEnabled && new theme.ProductScroller(a);
    }
    var d = {}, g;
    e.prototype = Object.assign({}, e.prototype, {init:function() {
      this.inModal || (this.updateProductInventory(), this.formSetup(), this.productSetup(), this.cache.mainSlider && (this.setImageSizes(), this.setImageZoom(), this.videoSetup(), this.initProductSlider(), this.customMediaListners(), this.addIdToRecentlyViewed()), this.cache.productMediaSlider && this.updateImageThumbs(this.cache.productMediaSlider), this.initSizeChart());
      var a = this.container.querySelector("#CopyReviewScript");
      if (a) {
        var c = this.container.querySelector("#PasteReviewScript");
        a.addEventListener("click", function() {
          k("copy this text", a, c);
        });
        c.addEventListener("click", function() {
          c.classList.add("hide");
          a.classList.remove("hide");
        });
      }
    }, onUnload:function() {
      theme.ProductMedia.removeSectionModels(this.sectionId);
      this.flickity && "function" === typeof this.flickity.destroy && this.flickity.destroy();
    }, formSetup:function() {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.availabilitySetup();
      this.initVariants();
    }, availabilitySetup:function() {
      var a = this.container.querySelector(this.selectors.availabilityContainer);
      a && (this.pickupAvailability = new theme.PickupAvailability(a));
    }, productSetup:function() {
      this.initModelViewerLibraries();
      this.initShopifyXrLaunch();
      theme.collapsibles.init(this.container);
    }, setImageSizes:function() {
      if (this.settings.hasImages) {
        var a = this.firstProductImage.currentSrc;
        a && (this.settings.imageSize = theme.Images.imageSize(a));
      }
    }, setImageZoom:function() {
      this.cache.productImages && "false" != this.cache.productImages.dataset.zoom && new theme.ImageZoom(this.cache.productImages, this.sectionId);
    }, addIdToRecentlyViewed:function() {
      var a = this.container.getAttribute("data-product-id");
      if (a) {
        var c = theme.recentlyViewedIds.indexOf(a);
        -1 < c && theme.recentlyViewedIds.splice(c, 1);
        theme.recentlyViewedIds.unshift(a);
        theme.config.hasLocalStorage && window.localStorage.setItem("recently-viewed", JSON.stringify(theme.recentlyViewedIds));
      }
    }, initVariants:function() {
      var a = this.container.querySelector(this.selectors.variantsJson);
      if (a) {
        this.variantsObject = JSON.parse(a.innerHTML);
        a = document.querySelector(this.selectors.variantInputId);
        if (null != a && "true" === a.dataset.manualvariant) {
          a = a.dataset.variants.split(",");
          var c = this.variantsObject;
          null != this.settings.imageSetName && null != document.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName.latinize() + '"]') && (this.settings.imageSetIndex = document.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName.latinize() + '"]').dataset.index, w = this.settings.imageSetIndex);
          for (var b of a) {
            var f = JSON.parse(JSON.stringify(this.variantsObject[0]));
            f.id = f.id;
            f[this.settings.imageSetIndex] = b.split("--")[0];
            f.options[0] = b.split("--")[0];
            c[a.indexOf(b)] = f;
          }
        }
        this.variants = new slate.Variants({container:this.container, enableHistoryState:this.settings.enableHistoryState, singleOptionSelector:this.selectors.singleOptionSelector, originalSelectorId:this.selectors.originalSelectorId, variants:this.variantsObject, imageSetName:this.settings.imageSetName, autoSelection:!1});
        this.container.querySelectorAll(this.selectors.variantColorSwatch).forEach(h => {
          h.addEventListener("change", function(m) {
          }.bind(this));
        });
        this.pickupAvailability && (this.pickupAvailability.updateContent(this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id), this.container.on("variantChange" + this.settings.namespace, this.updateAvailability.bind(this)));
        this.cache.datepicker && this.variants.currentVariant && (this.selectorNames.forEach(h => {
          var m = this.cache.datepicker.querySelector(h), p = m.dataset.array;
          h = "[data-disabled]" == h ? m.dataset.array.replaceAll(" ", "").replace("(", "").split("),") : m.dataset.array.split(",");
          var l = [];
          1 < h.length ? (h.forEach(n => {
            n = n.split("_");
            l.push({name:n[0].replaceAll(" ", "").toLowerCase(), value:n[1]});
          }), l = JSON.stringify(l)) : l = p;
          m.dataset.array = l;
        }), this.updateDatepicker(this.variants.currentVariant));
        this.container.on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this));
        if (this.container.querySelector(this.selectors.SKU)) {
          this.container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this));
        }
        if (b = this.container.querySelector(this.selectors.inventory)) {
          this.settings.inventory = !0, this.settings.inventoryThreshold = b.dataset.threshold, this.container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this));
        }
        theme.settings.dynamicVariantsEnable && (b = this.container.querySelector(this.selectors.currentVariantJson)) && (a = this.container.querySelector(this.selectors.variantType)) && new theme.VariantAvailability({container:this.container, namespace:this.settings.namespace, type:a.dataset.type, variantsObject:this.variantsObject, currentVariantObject:JSON.parse(b.innerHTML)});
        this.settings.imageSetName && ((b = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName.latinize() + '"]')) ? (this.settings.imageSetIndex = b.dataset.index, this.container.on("variantChange" + this.settings.namespace, this.updateImageSet.bind(this))) : this.settings.imageSetName = null);
      }
    }, initSizeChart:function() {
      var a = this.container.querySelector(".drawer-product__btn");
      if (a) {
        var c = document.querySelector("#CartDrawer");
        c && (this.cartDrawerClass = c.dataset.scheme);
        this.viewDrawer = new theme.Drawers("ProductDrawer-" + a.dataset.productid, "view-" + a.dataset.productid);
        a.addEventListener("click", function(b) {
          b = document.getElementById("ProductDrawer-" + a.dataset.productid);
          var f = this.cartDrawerClass.split(" ")[0];
          b.classList.add(f);
          b.classList.add("gradient");
          b && "false" == b.dataset.ismodal && b.setAttribute("data-ismodal", !0);
        }.bind(this));
      }
    }, initQtySelector:function() {
      this.container.querySelectorAll(".js-qty__wrapper").forEach(a => {
        new theme.QtySelector(a, {namespace:".product", sectionId:this.sectionId});
      });
    }, initAjaxProductForm:function() {
      new theme.AjaxProduct(this.cache.form);
    }, updateProductInventory:function() {
      window.inventories = window.inventories || {};
      var a = this.container.querySelector(".js-product-inventory-data");
      if (a) {
        var c = a.dataset.productId;
        window.inventories[c] = {};
        a.querySelectorAll(".js-variant-inventory-data").forEach(b => {
          window.inventories[c][b.dataset.id] = {quantity:b.dataset.quantity, policy:b.dataset.policy, incoming:b.dataset.incoming, next_incoming_date:b.dataset.date};
        });
      }
    }, updateCartButton:function(a) {
      var c = a.detail.variant, b = this.container.querySelector(this.selectors.addToCart);
      a = this.container.querySelector(this.selectors.addToCartText);
      var f = this.container.querySelector(this.selectors.shopifyPaymentButton), h = "true" === b.dataset.preorder;
      this.updateCustomVariant(!0);
      "true" == b.dataset.datepicker && this.updateDatepicker(c);
      null != this.cache.subscribe && (this.cache.subscribe.classList.add("hide"), b.classList.remove("hide"));
      if (c) {
        var m = window.inventories[this.productId][c.id];
        if (b.dataset.available = c.available) {
          if ("true" == b.dataset.datepicker && 0 == this.container.querySelector(".datepicker-quantity").value) {
            b.classList.add("disabled"), b.disabled = !0, a.textContent = theme.strings.selectDate, a.setAttribute("data-value", theme.strings.selectDate);
          } else if (null == m || 0 < m.quantity || !h) {
            b.classList.remove("disabled");
            b.classList.add("btn--secondary-accent");
            b.disabled = !1;
            null != f && f.classList.remove("hide");
            c = !1;
            for (b = 0; 5 > b; b++) {
              if (null != document.getElementById("BundleProduct-" + b) && 0 < document.getElementById("BundleProduct-" + b).selectedIndex) {
                c = !0;
                break;
              }
            }
            1 == c ? (a.textContent = theme.strings.addAllToCart, a.setAttribute("data-value", theme.strings.addAllToCart)) : (a.textContent = theme.strings.addToCart, a.setAttribute("data-value", theme.strings.addToCart));
          } else {
            b.classList.remove("disabled"), b.classList.remove("btn--secondary-accent"), b.disabled = !1, null != f && f.classList.add("hide");
          }
        } else {
          b.classList.add("disabled"), b.classList.remove("btn--secondary-accent"), b.disabled = !0, null != f && f.classList.add("hide"), a.textContent = theme.strings.soldOut, a.setAttribute("data-value", theme.strings.soldOut), null != this.cache.subscribe && (this.cache.subscribe.classList.remove("hide"), b.classList.add("hide")), this.updateCustomVariant(!1);
        }
      } else {
        b.classList.add("disabled"), b.classList.remove("btn--secondary-accent"), b.disabled = !0, null != f && f.classList.add("hide"), a.textContent = theme.strings.unavailable, a.setAttribute("data-value", theme.strings.unavailable), this.updateCustomVariant(!1);
      }
    }, updateCustomVariant:function(a) {
      this.container.querySelectorAll(".variant-input-wrap").forEach(c => {
        "true" == c.dataset.custom && (1 == a ? (c.querySelectorAll("input").forEach(b => {
          b.classList.remove("disabled");
        }), c.querySelectorAll("label").forEach(b => {
          b.classList.remove("disabled");
        })) : (c.querySelectorAll("input").forEach(b => {
          b.classList.add("disabled");
        }), c.querySelectorAll("label").forEach(b => {
          b.classList.add("disabled");
        })));
      });
    }, updateDatepicker:function(a) {
      this.selectorNames.forEach(c => {
        c = this.cache.datepicker.querySelector(c);
        if (c.dataset.array.includes("{")) {
          var b = JSON.parse(c.dataset.array);
          for (const h of a.options) {
            var f = b.find(m => m.name == h.replaceAll(" ", "").toLowerCase());
            if (void 0 != f) {
              break;
            }
          }
          void 0 != f && (c.value = f.value, c.dispatchEvent(new Event("change")));
        }
      });
      this.cache.datepicker.querySelector("[data-session-length]").dispatchEvent(new Event("input"));
    }, updatePrice:function(a) {
      a = a.detail.variant;
      this.cache.price && a && (this.cache.price.innerHTML = theme.Currency.formatMoney(a.price, theme.settings.moneyFormat), a.compare_at_price > a.price ? (this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(a.compare_at_price, theme.settings.moneyFormat), this.cache.priceWrapper.classList.remove("hide"), this.cache.price.classList.add("price__sale"), this.cache.regularPrice.setAttribute("aria-hidden", "false")) : (this.cache.priceWrapper && this.cache.priceWrapper.classList.add("hide"), 
      this.cache.price.classList.remove("price__sale"), this.cache.regularPrice.setAttribute("aria-hidden", "true")));
    }, updateUnitPrice:function(a) {
      (a = a.detail.variant) && a.unit_price ? (this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(a.unit_price, theme.settings.moneyFormat), this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(a), this.container.querySelector(this.selectors.unitWrapper).classList.remove("visually-invisible")) : this.container.querySelector(this.selectors.unitWrapper).classList.add("visually-invisible");
    }, imageSetArguments:function(a) {
      if (a = a ? a : this.variants ? this.variants.currentVariant : null) {
        a = this.settings.currentImageSet = this.getImageSetName(a[this.settings.imageSetIndex]).replace(/\s+/g, "-");
        a = this.settings.imageSetName + "_" + a;
        var c = this.settings.imageSetName + "_all";
        this.settings.currentSlideIndex = 0;
        return {cellSelector:'[data-group="' + a + '"]', imageSet:a, imageAll:c, initialIndex:this.settings.currentSlideIndex};
      }
    }, updateImageSet:function(a) {
      if (a = a ? a.detail.variant : this.variants ? this.variants.currentVariant : null) {
        var c = this.getImageSetName(a[this.settings.imageSetIndex]);
        this.settings.currentImageSet !== c && this.initProductSlider(a);
      }
    }, updateImageSetThumbs:function(a, c) {
      this.cache.productThumbs.querySelectorAll(".product-single__thumbnail-item").forEach(b => {
        b.classList.toggle("hide", b.dataset.group !== a && b.dataset.group !== c);
      });
    }, getImageSetName:function(a) {
      return a.toLowerCase();
    }, updateImageThumbs:function(a) {
      if (a && "true" != a.getAttribute("data-login-required")) {
        this.container.querySelectorAll("video").forEach(b => {
          this.initDurationLabel(b, "mp4");
        });
        a.appendChild(this.cache.productThumbs);
        var c = a.getElementsByClassName("product-single__thumbnail-item");
        c && 1 < c.length && ("false" == this.cache.productImages.getAttribute("data-has-media") && a.classList.remove("hide"), this.cache.productThumbs.classList.remove("hide"));
      }
    }, updateSku:function(a) {
      a = a.detail.variant;
      var c = "";
      a && (a.sku && (c = a.sku), this.container.querySelector(this.selectors.SKU).textContent = c);
    }, updateContent:function(a, c) {
      var b = window.inventories[this.productId][c.id], f;
      "shopify" == c.inventory_management ? f = b.quantity : "" == c.inventory_management && (f = 0);
      var h = !0;
      if (0 >= f || "inventory" == a && f > this.settings.inventoryThreshold) {
        h = !1;
      }
      "inventory" == a && this.toggleInventoryQuantity(c, h, f, b);
      "availability" == a && (h ? this.container.querySelector(this.selectors.availabilityContainer).classList.remove("hide") : this.container.querySelector(this.selectors.availabilityContainer).classList.add("hide"), this.pickupAvailability.updateContent(c.id));
    }, updateInventory:function(a) {
      (a = a.detail.variant) && a.inventory_management && "continue" != a.inventory_policy ? window.inventories && window.inventories[this.productId] && this.updateContent("inventory", a) : (this.toggleInventoryQuantity(a, !1), this.toggleIncomingInventory(!1));
    }, updateAvailability:function(a) {
      (a = a.detail.variant) ? this.updateContent("availability", a) : this.container.querySelector(this.selectors.availabilityContainer).classList.add("hide");
    }, toggleInventoryQuantity:function(a, c, b, f) {
      c = this.container.querySelector(this.selectors.inventory);
      parseInt(b) <= parseInt(this.settings.inventoryThreshold) ? (this.cache.price.classList.contains("hide") && this.cache.price.classList.remove("hide"), 0 >= parseInt(b) ? a.available || f.next_incoming_date ? (c.parentNode.classList.add("inventory--low"), a.available ? c.parentNode.classList.remove("inventory--out") : c.parentNode.classList.add("inventory--out"), c.textContent = theme.strings.waitingForStock, c = !1, "true" === f.incoming && parseInt(b) <= this.settings.inventoryThreshold && 
      (c = !0), this.toggleIncomingInventory(c, a.available, f.next_incoming_date)) : (c.parentNode.classList.remove("inventory--low"), c.parentNode.classList.add("inventory--out"), c.textContent = theme.strings.soldOut) : (c.parentNode.classList.remove("inventory--out"), c.parentNode.classList.add("inventory--low"), c.textContent = theme.strings.stockLabel.replace("[count]", b))) : null == a && void 0 == f ? (c.parentNode.classList.remove("inventory--low"), c.parentNode.classList.add("inventory--out"), 
      c.textContent = theme.strings.unavailable, this.cache.price.classList.add("hide")) : (c.parentNode.classList.remove("inventory--out"), c.parentNode.classList.remove("inventory--low"), c.textContent = theme.strings.inStockLabel);
    }, toggleIncomingInventory:function(a, c, b) {
      var f = this.container.querySelector(this.selectors.incomingInventory);
      if (f) {
        var h = this.container.querySelector(this.selectors.inventory);
        a && (a = c ? theme.strings.willNotShipUntil.replace("[date]", b) : theme.strings.willBeInStockAfter.replace("[date]", b), b || (a = theme.strings.waitingForStock), f.classList.remove("hide"), h.textContent = a);
      }
    }, getThumbIndex:function(a) {
      return a.dataset.index;
    }, updateVariantImage:function(a) {
      a = a.detail.variant;
      theme.Images.getSizedImageUrl(a.featured_media.preview_image.src, this.settings.imageSize);
      a = this.container.querySelector('.product-single__thumbnail[data-id="' + a.featured_media.id + '"]');
      a = this.getThumbIndex(a);
      "undefined" !== typeof a && this.flickity && this.flickity.goToSlide(a);
    }, initProductSlider:function(a) {
      if (1 >= this.cache.mainSlider.querySelectorAll(".product-single_main-slide").length) {
        (a = this.cache.mainSlider.querySelector(".product-single_main-slide")) && a.classList.add("is-selected");
      } else {
        this.flickity && "function" === typeof this.flickity.destroy && this.flickity.destroy();
        if (!a) {
          var c = this.cache.mainSlider.querySelector(".starting-slide");
          this.settings.currentSlideIndex = this._slideIndex(c);
          this.currentSlide = c;
        }
        var b = {adaptiveHeight:!0, avoidReflow:!0, initialIndex:this.settings.currentSlideIndex, childNav:this.cache.productThumbs, childNavScroller:this.cache.productThumbImages, childVertical:"beside" === this.cache.productThumbs.dataset.position, pageDots:!0, wrapAround:!0, prevNextButtons:"image_arrows" === this.cache.productThumbs.dataset.arrows, callbacks:{onInit:this.onSliderInit.bind(this), onChange:this.onSlideChange.bind(this)}};
        this.settings.imageSetName && (a = this.imageSetArguments(a), b = Object.assign({}, b, a), this.updateImageSetThumbs(b.imageSet, b.imageAll));
        a = 50;
        Shopify.designMode && (a = 1000);
        setTimeout(() => {
          this.flickity = new theme.Slideshow(this.cache.mainSlider, b, !1);
          if (this.cache.productMediaSlider) {
            var f = (new URL(window.location.href)).searchParams.get("index");
            this.flickity.goToSlide(f);
          }
        }, a);
        setTimeout(() => {
          this.flickity.resize();
        }, 1.2 * a);
      }
    }, onSliderInit:function(a) {
      this.settings.imageSetName && this.prepMediaOnSlide(a);
    }, onSlideChange:function(a) {
      if (this.flickity) {
        var c = this.cache.mainSlider.querySelector('.product-single_main-slide[data-index="' + this.settings.currentSlideIndex + '"]'), b = this.settings.imageSetName ? this.cache.mainSlider.querySelectorAll(".flickity-slider .product-single_main-slide")[a] : this.cache.mainSlider.querySelector('.product-single_main-slide[data-index="' + a + '"]');
        c.setAttribute("tabindex", "-1");
        b.setAttribute("tabindex", 0);
        this.stopMediaOnSlide(c, !0);
        this.prepMediaOnSlide(b);
        this.settings.currentSlideIndex = a;
        this.currentSlide = b;
      }
    }, stopMediaOnSlide(a, c) {
      var b = a.querySelector(".product__video");
      if (b) {
        var f = this._getVideoType(b);
        b = this._getVideoDivId(b);
        if ("youtube" === f) {
          if (d[b].videoPlayer) {
            this.cache.productMediaSlider && (a = [d[b].videoPlayer.playerInfo.currentTime, parseInt(d[b].videoPlayer.playerInfo.currentTime / d[b].videoPlayer.playerInfo.duration * 100)], window.localStorage.setItem(b, JSON.stringify(a)), this.initDurationSlider(d[b].videoPlayer, "youtube"));
            c && d[b].videoPlayer.stopVideo();
            return;
          }
        } else if ("mp4" === f) {
          this.cache.productMediaSlider && (f = this.container.querySelector("#" + b), a = [f.currentTime, parseInt(f.currentTime / f.duration * 100)], window.localStorage.setItem(f.id, JSON.stringify(a)), this.initDurationSlider(f, "mp4"));
          c && this.stopMp4Video(b);
          return;
        }
      }
      (c = a.querySelector(this.selectors.media)) && c.dispatchEvent(new CustomEvent("mediaHidden", {bubbles:!0, cancelable:!0}));
    }, prepMediaOnSlide(a) {
      if (a) {
        var c = a.querySelector(".product__video");
        if (c) {
          this.flickity.reposition();
          var b = this._getVideoType(c);
          c = this._getVideoDivId(c);
          if ("youtube" === b) {
            if (d[c].videoPlayer && "sound" !== d[c].options.style) {
              (a = window.localStorage.getItem(c)) && d[c].videoPlayer.seekTo(parseInt(JSON.parse(a)[0]), !0);
              d[c].videoPlayer.playVideo();
              return;
            }
          } else {
            "mp4" === b && this.playMp4Video(c);
          }
        }
        if (b = a.querySelector(this.selectors.media)) {
          b.dispatchEvent(new CustomEvent("mediaVisible", {bubbles:!0, cancelable:!0})), a.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0), a.querySelector(".product-single__close-media").setAttribute("tabindex", 0);
        }
      }
    }, _slideIndex:function(a) {
      return a.getAttribute("data-index");
    }, initModelViewerLibraries:function() {
      var a = this.container.querySelectorAll(this.selectors.media);
      1 > a.length || theme.ProductMedia.init(a, this.sectionId);
    }, initShopifyXrLaunch:function() {
      document.addEventListener("shopify_xr_launch", function() {
        this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")").dispatchEvent(new CustomEvent("xrLaunch", {bubbles:!0, cancelable:!0}));
      }.bind(this));
    }, customMediaListners:function() {
      document.querySelectorAll(this.selectors.closeMedia).forEach(c => {
        c.addEventListener("click", function() {
          var b = this.cache.mainSlider.querySelector(".is-selected").querySelector(this.selectors.media);
          b && b.dispatchEvent(new CustomEvent("mediaHidden", {bubbles:!0, cancelable:!0}));
        }.bind(this));
      });
      var a = this.container.querySelectorAll("model-viewer");
      a.length && a.forEach(c => {
        c.addEventListener("shopify_model_viewer_ui_toggle_play", function(b) {
          this.mediaLoaded(b);
        }.bind(this));
        c.addEventListener("shopify_model_viewer_ui_toggle_pause", function(b) {
          this.mediaUnloaded(b);
        }.bind(this));
      });
    }, mediaLoaded:function(a) {
      this.container.querySelectorAll(this.selectors.closeMedia).forEach(c => {
        c.classList.remove("hide");
      });
      this.flickity && this.flickity.setDraggable(!1);
    }, mediaUnloaded:function(a) {
      this.container.querySelectorAll(this.selectors.closeMedia).forEach(c => {
        c.classList.add("hide");
      });
      this.flickity && this.flickity.setDraggable(!0);
    }, videoSetup:function() {
      var a = this.cache.mainSlider.querySelectorAll(".product__video");
      if (!a.length) {
        return !1;
      }
      a.forEach(c => {
        var b = c.dataset.videoType;
        "youtube" === b ? this.initYoutubeVideo(c) : "vimeo" === b ? this.initVimeoVideo(c) : "mp4" === b && this.initMp4Video(c);
      });
      window.addEventListener("beforeunload", function(c) {
        this.stopMediaOnSlide(this.currentSlide, !1);
      }.bind(this));
    }, initDurationLabel:function(a, c, b) {
      var f = this.cache.productThumbs;
      "youtube" === c && b ? (c = this._getVideoLength(a.getDuration()), f.querySelector("#" + b.replace("ProductVideo-", "ThumbnailVideo-")).innerHTML = c, "NaN:NaN" != String(c) && f.querySelector("#" + b.replace("ProductVideo-", "ThumbnailVideo-")).classList.remove("hide"), this.initDurationSlider(a, "youtube", b)) : "mp4" === c && (c = this._getVideoLength(a.duration), f.querySelector("#" + a.id.replace("ProductVideo-", "ThumbnailVideo-")).innerHTML = c, "NaN:NaN" != String(c) && f.querySelector("#" + 
      a.id.replace("ProductVideo-", "ThumbnailVideo-")).classList.remove("hide"), a.addEventListener("loadedmetadata", function(h) {
        f.querySelector("#" + h.target.id.replace("ProductVideo-", "ThumbnailVideo-")).innerHTML = this._getVideoLength(h.target.duration);
        f.querySelector("#" + h.target.id.replace("ProductVideo-", "ThumbnailVideo-")).classList.remove("hide");
      }.bind(this)), this.initDurationSlider(a, "mp4"));
    }, initDurationSlider:function(a, c, b) {
      if ("youtube" === c && b) {
        var f = b;
        var h = window.localStorage.getItem(f);
      } else {
        "mp4" === c && a && (f = a.id, h = window.localStorage.getItem(f));
      }
      f && h && (a = this.cache.productThumbs.querySelector("#" + f.replace("ProductVideo-", "ThumbnailVideoSlider-")), a.style.width = JSON.parse(h)[1] + "%", a.parentElement.classList.remove("hide"));
    }, initYoutubeVideo:function(a) {
      d[a.id] = new theme.YouTube(a.id, {videoId:a.dataset.videoId, videoParent:".product__video-wrapper", autoplay:!1, style:a.dataset.videoStyle, loop:a.dataset.videoLoop, controls:!0, events:{onReady:this.youtubePlayerReady.bind(this), onStateChange:this.youtubePlayerStateChange.bind(this)}});
    }, initVimeoVideo:function(a) {
      d[a.id] = new theme.VimeoPlayer(a.id, a.dataset.videoId, {videoParent:".product__video-wrapper", autoplay:!1, style:a.dataset.videoStyle, loop:a.dataset.videoLoop, controls:!0});
    }, youtubePlayerReady:function(a) {
      var c = a.target.getIframe().id;
      if (d[c]) {
        a = d[c];
        var b = a.videoPlayer;
        this.videoPlayer = b;
        document.getElementById(c).parentNode.classList.remove("loading");
        document.getElementById(c).parentNode.classList.add("loaded");
        this._isFirstSlide(c) && "sound" !== a.options.style && ((a = window.localStorage.getItem(b.id)) && b.seekTo(parseInt(JSON.parse(a)[0]), !0), b.playVideo());
        this.cache.productMediaSlider && setTimeout(function() {
          this.initDurationLabel(b, "youtube", c);
        }.bind(this), 200);
      }
    }, _isFirstSlide:function(a) {
      return this.cache.mainSlider.querySelector(".starting-slide #" + a);
    }, youtubePlayerStateChange:function(a) {
      var c = a.target.getIframe().id, b = d[c];
      switch(a.data) {
        case -1:
          b.attemptedToPlay && document.getElementById(c).parentNode.classList.add("video-interactable");
          break;
        case 0:
          b && "true" === b.options.loop && b.videoPlayer.playVideo();
          break;
        case 3:
          b.attemptedToPlay = !0;
      }
    }, initMp4Video:function(a) {
      d[a.id] = {id:a.id, type:"mp4"};
      this._isFirstSlide(a.id) && this.playMp4Video(a.id);
      setTimeout(function() {
      }.bind(this), 200);
    }, stopVideos:function() {
      var a;
      for ([, a] of Object.entries(d)) {
        a.videoPlayer ? "function" === typeof a.videoPlayer.stopVideo && a.videoPlayer.stopVideo() : "mp4" === a.type && this.stopMp4Video(a.id);
      }
    }, _getVideoType:function(a) {
      return a.getAttribute("data-video-type");
    }, _getVideoDivId:function(a) {
      return a.id;
    }, _getVideoLength:function(a) {
      var c = Math.floor(a / 3600), b = Math.floor((a - 3600 * c) / 60);
      a = Math.floor(a - 3600 * c - 60 * b);
      c = 0 < parseInt(c) ? c + ":" : "";
      b = 10 > parseInt(b) ? "0" + b : b;
      a = 10 > parseInt(a) ? "0" + a : a;
      return c + b + ":" + a;
    }, playMp4Video:function(a) {
      var c = this.container.querySelector("#" + a);
      a = c.play();
      var b = window.localStorage.getItem(c.id);
      b && (b = JSON.parse(b)[1], c.addEventListener("loadeddata", function() {
        c.currentTime = b / 100 * c.duration;
      }.bind(this)));
      c.setAttribute("controls", "");
      c.focus();
      c.addEventListener("focusout", this.returnFocusToThumbnail.bind(this));
      void 0 !== a && a.then(function() {
      }).catch(function(f) {
        c.setAttribute("controls", "");
        c.closest(".product__video-wrapper").setAttribute("data-video-style", "unmuted");
      });
    }, stopMp4Video:function(a) {
      a = this.container.querySelector("#" + a);
      a.removeEventListener("focusout", this.returnFocusToThumbnail.bind(this));
      a && "function" === typeof a.pause && (a.removeAttribute("controls"), a.pause());
    }, returnFocusToThumbnail:function() {
      var a = this.container.querySelector('.product__thumb-item[data-index="' + this.settings.currentSlideIndex + '"] a');
      a && a.focus();
    }});
    return e;
  }();
  theme.ProductScroller = function() {
    function k(l) {
      this.container = l;
      this.sectionId = l.getAttribute("data-section-id");
      this.messageEnabled = l.getAttribute("data-message-enabled");
      this.namespace = ".product-section" + this.sectionId;
      this.productImageTopHeight = this.productFormTopHeight = 0;
      this.selectors = {productSticky:".product-single__sticky", blurredProduct:".blurred-product", pageDots:".flickity-page-dots", productCover:".product_cover", productImageWrapper:"ProductImageWrapper", productImages:"#ProductImages-", productImagesMobile:"ProductImagesMobile-", productSingleSticky:".product-single__sticky-"};
      e = document.querySelector(this.selectors.productImages + this.sectionId);
      this.productFormImageWrapperHeight = (this.productFormImageWrapper = document.querySelector("#ProductFormImageWrapper-" + this.sectionId)) ? this.productFormImageWrapper.offsetHeight : 0;
      d = document.querySelector(this.selectors.productImages + this.sectionId).offsetHeight;
      g = document.querySelector("#ProductForm-" + this.sectionId);
      document.querySelector(".description_desktop") && document.querySelector(".description_desktop");
      a = document.querySelector("#StickyHeaderWrap");
      c = 0.5 * (g.offsetHeight - this.productFormImageWrapperHeight);
      b = 0;
      a && document.documentElement.style.setProperty("--product_sidebar_padding", Math.round(window.innerHeight) - a.offsetHeight + "px");
      this.init();
    }
    var e, d, g, a, c, b, f = !1, h = !0, m = !1, p = !1;
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      this.resizeContainer();
      if ("true" != this.messageEnabled) {
        this.windowWidth = window.innerWidth;
        window.on("resize" + this.namespace, this.resizeContainer.bind(this));
        window.on("scroll" + this.namespace, this.scrollHandler.bind(this));
        document.documentElement.style.setProperty("--sticky_divider-padding", 1.15 * d + "px");
        var l = document.querySelector(".blurred-container"), n = getComputedStyle(document.body).getPropertyValue("--gradient-background");
        l && n && (this.maxOpacity = l.dataset.opacity, l.style.backgroundColor = this.addAlpha(n, this.maxOpacity));
      }
    }, setupImageViewer:function() {
      var l = window.matchMedia("(min-width: 590px)");
      l.matches && p ? (document.getElementById(this.selectors.productImageWrapper + this.sectionId).appendChild(e), p = !1) : l.matches || p || (document.getElementById("ProductFormImageWrapper-" + this.sectionId).appendChild(e), p = !0);
    }, resizeContainer:function() {
      if ("true" != this.messageEnabled) {
        if (window.innerWidth != this.windowWidth) {
          this.windowWidth = window.innerWidth;
        } else {
          return;
        }
        this.setupImageViewer();
        this.formTopHeight();
        e = document.querySelector(this.selectors.productImages + this.sectionId);
        d = e.offsetHeight;
        document.querySelector(".blurred-container").style.height = d + "px";
      }
      var l = 0, n = 0, q = document.querySelector("#SiteHeader"), r = document.querySelector("#SiteAnnouncement"), t = document.querySelector("#AnnouncementWrapper");
      b = 0;
      null != t && null != r && (l = r.offsetHeight, "true" == t.dataset.sticky && (b = l));
      null != q && (n = q.offsetHeight, "sticky" == q.dataset.sticky && (b += n));
      document.querySelector(this.selectors.productImages + this.sectionId).style.top = l + n + "px";
      document.documentElement.style.setProperty("--sticky-padding", b + 50 + "px");
      document.documentElement.style.setProperty("--sticky-padding-desktop", b + 40 + "px");
    }, formTopHeight:function() {
      this.productFormTopHeight = 0;
      if (g.querySelector(".product-single__sticky")) {
        this.productImageTopHeight = g.querySelector(".product-single__sticky").offsetTop;
        var l = g.querySelector(".product-single__sticky").previousSibling;
        this.productImageTopHeight = l.offsetTop + l.offsetHeight;
        l = this.container.querySelectorAll(".product-form__controls-group");
        for (var n = 0; n < l.length && !l[n].classList.contains("product-single__sticky"); n++) {
          this.productFormTopHeight += l[n].offsetHeight;
        }
      }
    }, addAlpha:function(l, n) {
      return l + Math.round(255 * Math.min(Math.max(n ?? 1, 0), 1)).toString(16).toUpperCase();
    }, fade_in:function(l, n, q = "") {
      if (null != l) {
        l.style.opacity = 0;
        let r = +new Date(), t = function() {
          l.style.opacity = +l.style.opacity + (new Date() - r) / n;
          r = +new Date();
          1 > +l.style.opacity ? window.requestAnimationFrame && requestAnimationFrame(t) || setTimeout(t, 16) : "" !== q && q();
        };
        t();
      }
    }, fade_out:function(l, n, q = "") {
      if (null != l) {
        l.style.opacity = 1;
        let r = +new Date(), t = function() {
          l.style.opacity = +l.style.opacity - (new Date() - r) / n;
          r = +new Date();
          0 < +l.style.opacity ? window.requestAnimationFrame && requestAnimationFrame(t) || setTimeout(t, 16) : "" !== q && q();
        };
        t();
      }
    }, scrollHandler:function() {
      var l = window.pageYOffset, n = document.querySelector(".blurred-container"), q = document.querySelector("#ProductSection-" + this.sectionId).offsetTop;
      d = document.querySelector(this.selectors.productImages + this.sectionId).offsetHeight + 25;
      g = document.querySelector("#ProductForm-" + this.sectionId);
      c = 0.5 * (g.offsetHeight - this.productFormImageWrapperHeight) + q;
      a = document.querySelector("#SiteHeader");
      q = 25 + q - b + this.productFormTopHeight;
      var r = this.productImageTopHeight, t = document.querySelector("#ProductForm-" + this.sectionId).offsetHeight;
      r = q + t - r - d - 35;
      5 > q && (q = 25);
      l >= q && l < r ? f || (document.querySelector("#ProductFormImageWrapper-" + this.sectionId).classList.add("product-single__blurer"), f = !0, h = !1, n.style.display = "inline-block", document.querySelector(this.selectors.productSingleSticky + this.sectionId).style.zIndex = -1, this.fade_in(document.querySelector(this.selectors.blurredProduct), 300), this.fade_out(document.querySelector(this.selectors.pageDots), 300)) : h || (document.querySelector("#ProductFormImageWrapper-" + this.sectionId).classList.remove("product-single__blurer"), 
      f = !1, h = !0, document.querySelector(this.selectors.productSingleSticky + this.sectionId).style.zIndex = 1, this.fade_out(document.querySelector(this.selectors.blurredProduct), 500), this.fade_in(document.querySelector(this.selectors.pageDots), 500), setTimeout(function() {
        h && (n.style.display = "none");
      }, 500));
      l >= c ? m || (m = !0, document.querySelectorAll(this.selectors.productCover).forEach(v => {
        this.fade_in(v, 700);
      })) : m && (m = !1, document.querySelectorAll(this.selectors.productCover).forEach(v => {
        this.fade_out(v, 500);
      }));
    }});
    return k;
  }();
  theme.Recommendations = function() {
    function k(e) {
      this.container = e;
      this.sectionId = e.getAttribute("data-section-id");
      this.productLimit = e.dataset.limit;
      this.url = e.dataset.url;
      this.content = e.dataset.content;
      this.recommendations = this.container.id;
      theme.initWhenVisible({element:e, callback:this.init.bind(this), threshold:500});
    }
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      var e = document.getElementById(this.recommendations);
      if (e && "false" !== e.dataset.enable) {
        if (Shopify.designMode) {
          var d = e.querySelector(" .product-recommendations-loader");
          d && (d.innerHTML = "");
        }
        d = this.url;
        if ("recent" == this.content) {
          var g = "", a = 0;
          theme.recentlyViewedIds.forEach(function(c) {
            c === this.sectionId || a >= this.productLimit || (g += "id:" + c + " OR ", a++);
          }.bind(this));
          d += encodeURIComponent(g);
        }
        fetch(d).then(c => c.text()).then(c => {
          const b = document.createElement("div");
          b.innerHTML = c;
          (c = b.querySelector(" .product-recommendations-loader")) && c.innerHTML.trim().length ? (e.querySelector(".product-recommendations").innerHTML = c.innerHTML, new theme.ProductGrid(this.container), "slider" == this.container.dataset.style && new theme.TabSwitcher(this.container)) : this.container.classList.add("hide");
        }).catch(c => {
          this.container.classList.add("hide");
          console.error(c);
        });
      }
    }});
    return k;
  }();
  theme.ProductMedia = function() {
    function k(b) {
      if (!b) {
        if (window.ShopifyXR) {
          for (var f in g) {
            if (g.hasOwnProperty(f) && (b = g[f], !b.loaded)) {
              var h = document.querySelector("#ModelJson-" + f);
              window.ShopifyXR.addModels(JSON.parse(h.innerHTML));
              b.loaded = !0;
            }
          }
          window.ShopifyXR.setupXRElements();
        } else {
          document.addEventListener("shopify_xr_initialized", function() {
            k();
          });
        }
      }
    }
    function e(b) {
      if (!b) {
        for (var f in a) {
          a.hasOwnProperty(f) && (b = a[f], !b.modelViewerUi && Shopify && (b.modelViewerUi = new Shopify.ModelViewerUI(b.element)), d(b));
        }
      }
    }
    function d(b) {
      var f = c[b.sectionId];
      b.container.addEventListener("mediaVisible", function() {
        f.element.setAttribute("data-shopify-model3d-id", b.modelId);
        theme.config.isTouch || b.modelViewerUi.play();
      });
      b.container.addEventListener("mediaHidden", function() {
        f.element.setAttribute("data-shopify-model3d-id", f.defaultId);
        b.modelViewerUi.pause();
      });
      b.container.addEventListener("xrLaunch", function() {
        b.modelViewerUi.pause();
      });
    }
    var g = {}, a = {}, c = {};
    return {init:function(b, f) {
      g[f] = {loaded:!1};
      b.forEach(function(h, m) {
        var p = h.dataset.mediaId, l = h.querySelector("model-viewer"), n = l.dataset.modelId;
        0 === m && (m = h.closest("[data-product-single-media-group]").querySelector("[data-shopify-xr]"), c[f] = {element:m, defaultId:n});
        a[p] = {modelId:n, sectionId:f, container:h, element:l};
      });
      window.Shopify.loadFeatures([{name:"shopify-xr", version:"1.0", onLoad:k}, {name:"model-viewer-ui", version:"1.0", onLoad:e}]);
      theme.LibraryLoader.load("modelViewerUiStyles");
    }, removeSectionModels:function(b) {
      for (var f in a) {
        a.hasOwnProperty(f) && a[f].sectionId === b && delete a[f];
      }
      delete g[b];
    }};
  }();
  theme.ImageZoom = function() {
    function k(d, g) {
      this.container = d;
      this.sectionId = g;
      e = ".js-image-zoom--" + g;
      this.type = this.container.dataset.zoom;
      this.namespace = ".image-zoom_" + this.sectionId;
      this.inSlideshow = !1;
      d && "false" !== d.dataset.zoom && this.init();
    }
    var e = ".js-image-zoom--";
    k.prototype = Object.assign({}, k.prototype, {init:function() {
      this.container.querySelectorAll(e).forEach(d => {
        d.on("click" + this.namespace, this.triggerClick.bind(this));
      });
    }, triggerClick:function(d) {
      this.inSlideshow = this.container.dataset && "true" === this.container.dataset.hasSlideshow ? !0 : !1;
      if (d.currentTarget.getAttribute("data-alignment")) {
        var g = d.currentTarget.getAttribute("data-alignment"), a = document.querySelector("#ProductImageZoom--" + this.sectionId), c = a.getAttribute("data-alignment"), b = "true" == a.getAttribute("data-removable") ? !0 : !1;
        c != g && (a.classList.remove(c), a.classList.add(g), a.setAttribute("data-alignment", g), a.querySelector(".modal--image-zoom").classList.remove("modal--" + c), a.querySelector(".modal--image-zoom").classList.add("modal--" + g));
      }
      d = this.inSlideshow ? this.container.querySelector(".is-selected") : d.currentTarget;
      d = this.inSlideshow ? this.getChildIndex(d) : d.dataset.index;
      void 0 == this.modal || void 0 != this.modal && b ? (void 0 != this.modal && b && (a.querySelector(".modal--image-zoom").innerHTML = ""), this.items = this.getImageData(), this.initGallery(this.items, d)) : (this.flickity && (this.flickity.resize(), this.flickity.goToSlide(d - 1)), this.modal.open());
    }, getChildIndex:function(d) {
      for (var g = 0; null != (d = d.previousSibling);) {
        g++;
      }
      return g + 1;
    }, getImageData:function() {
      this.images = this.inSlideshow ? this.container.querySelectorAll(".flickity-viewport .image-zoom") : this.container.querySelectorAll(".image-zoom");
      var d = [], g;
      this.images.forEach(a => {
        g ||= a.getAttribute("data-image-group");
        a.closest(".tab-switcher__collection") && a.closest(".tab-switcher__collection").classList.contains("hide") || (a = {msrc:"https:" + (a.dataset.currentSrc || a.dataset.src), src:a.getAttribute("data-lightbox-src"), w:a.getAttribute("data-lightbox-width"), h:a.getAttribute("data-lightbox-height"), el:a, initialZoomLevel:0.5}, d.push(a));
      });
      return d;
    }, initGallery:function(d, g) {
      var a = document.querySelector(".modal--image-zoom--" + this.sectionId);
      a.getAttribute("data-section-id");
      a.innerHTML = "";
      for (var c = 0; c < d.length; c++) {
        var b = `
            <div class="grid-product__image">
              <img class="product__image"
                src="${d[c].msrc}"
                data-aspectratio="${d[c].w / d[c].h}"
                data-sizes="auto"
                style="object-fit: contain; width: auto">
            </div>`;
        const f = document.createElement("div");
        f.innerHTML = b;
        a.appendChild(f.firstElementChild);
      }
      void 0 == this.modal && (this.modal = new theme.Modals("ProductImageZoom--" + this.sectionId, "ProductImageZoom--" + this.sectionId));
      this.modal.open();
      setTimeout(function() {
        if (a.classList.contains("modal--slideshow") && 1 < d.length) {
          this.flickity = new theme.Slideshow(a, {adaptiveHeight:!1, avoidReflow:!0, pageDots:!0, autoPlay:!1, pauseAutoPlayOnHover:!1, prevNextButtons:!0}), this.flickity.goToSlide(g - 1);
        } else {
          var f = document.querySelector(".modal--image-zoom"), h = a.querySelectorAll(".product__image")[g - 1];
          h && ("vertical" == this.type ? f.scrollLeft = h.offsetLeft - 20 : f.scrollTop = h.offsetTop - 20);
        }
      }.bind(this), 350);
    }});
    return k;
  }();
  (function(k) {
    "loading" != document.readyState ? k() : document.addEventListener("DOMContentLoaded", k);
  })(function() {
    theme.sections.register("product", theme.Product);
    theme.sections.register("product-bundle", theme.ProductBundle);
    theme.sections.register("pickup-availability", theme.PickupAvailability);
    theme.sections.register("footer-header", theme.FooterHeaderSection);
    theme.sections.register("product-recommendations", theme.Recommendations);
  });
})();